// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"fa09a82f","769":"e77813dc"}[chunkId] + ".chunk.css";
};